// Données simulées pour l'application HealthBridge Sys

export const mockDoctors = [
  {
    id: 1,
    name: 'Dr. Jean Mukamba',
    specialty: 'Cardiologie',
    hospital: 'Hôpital Général de Kinshasa',
    zone: 'Kinshasa',
    phone: '+243 81 234 5678',
    email: 'jean.mukamba@healthbridge.cd',
    experience: '15 ans',
    rating: 4.8,
    avatar: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop&crop=face',
    isOnline: true
  },
  {
    id: 2,
    name: 'Dr. Marie Kabongo',
    specialty: 'Pédiatrie',
    hospital: 'Centre Hospitalier de Lubumbashi',
    zone: 'Lubumbashi',
    phone: '+243 99 876 5432',
    email: 'marie.kabongo@healthbridge.cd',
    experience: '12 ans',
    rating: 4.9,
    avatar: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop&crop=face',
    isOnline: false
  },
  {
    id: 3,
    name: 'Dr. Pierre Mbuyi',
    specialty: 'Neurologie',
    hospital: 'Hôpital Provincial de Matadi',
    zone: 'Matadi',
    phone: '+243 85 123 4567',
    email: 'pierre.mbuyi@healthbridge.cd',
    experience: '20 ans',
    rating: 4.7,
    avatar: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=150&h=150&fit=crop&crop=face',
    isOnline: true
  }
];

export const mockPatients = [
  {
    id: 1,
    name: 'Patient A',
    age: 45,
    gender: 'M',
    phone: '+243 81 111 1111',
    zone: 'Kinshasa',
    diagnosis: 'Hypertension',
    doctor: 'Dr. Jean Mukamba',
    lastVisit: '2024-01-15',
    status: 'En traitement'
  },
  {
    id: 2,
    name: 'Patient B',
    age: 32,
    gender: 'F',
    phone: '+243 99 222 2222',
    zone: 'Lubumbashi',
    diagnosis: 'Diabète',
    doctor: 'Dr. Marie Kabongo',
    lastVisit: '2024-01-10',
    status: 'Stable'
  }
];

export const mockDiseases = [
  {
    id: 1,
    name: 'Malaria',
    description: 'Maladie infectieuse transmise par les moustiques',
    symptoms: ['Fièvre', 'Maux de tête', 'Fatigue'],
    treatment: 'Artémisinine',
    prevalence: 'Élevée',
    zone: 'Toutes zones'
  },
  {
    id: 2,
    name: 'Diabète',
    description: 'Trouble métabolique caractérisé par une hyperglycémie',
    symptoms: ['Soif excessive', 'Urination fréquente', 'Fatigue'],
    treatment: 'Insuline, régime alimentaire',
    prevalence: 'Modérée',
    zone: 'Urbain'
  }
];

export const mockStudies = [
  {
    id: 1,
    title: 'Étude sur la prévalence du paludisme',
    researcher: 'Dr. Jean Mukamba',
    zone: 'Kinshasa',
    startDate: '2024-01-01',
    endDate: '2024-06-30',
    status: 'En cours',
    participants: 500
  },
  {
    id: 2,
    title: 'Impact de la nutrition sur la santé maternelle',
    researcher: 'Dr. Marie Kabongo',
    zone: 'Lubumbashi',
    startDate: '2023-09-01',
    endDate: '2024-03-31',
    status: 'Terminée',
    participants: 300
  }
];

export const mockZones = [
  {
    id: 1,
    name: 'Kinshasa',
    coordinates: [-4.4419, 15.2663],
    population: 12000000,
    hospitals: 25,
    doctors: 150,
    status: 'Active'
  },
  {
    id: 2,
    name: 'Lubumbashi',
    coordinates: [-11.6642, 27.4794],
    population: 2000000,
    hospitals: 8,
    doctors: 45,
    status: 'Active'
  },
  {
    id: 3,
    name: 'Matadi',
    coordinates: [-5.8167, 13.4500],
    population: 500000,
    hospitals: 3,
    doctors: 20,
    status: 'Active'
  }
];

export const mockChatMessages = [
  {
    id: 1,
    senderId: 1,
    receiverId: 2,
    message: 'Bonjour Dr. Marie, j\'ai un patient avec des symptômes de fièvre persistante...',
    timestamp: '2024-01-15T10:30:00Z',
    isRead: false
  },
  {
    id: 2,
    senderId: 2,
    receiverId: 1,
    message: 'Bonjour Dr. Jean, pouvez-vous me donner plus de détails sur les symptômes?',
    timestamp: '2024-01-15T10:35:00Z',
    isRead: true
  }
];

export const mockLibraryPdfs = [
  {
    id: 1,
    title: 'Guide de diagnostic cardiologique',
    author: 'Dr. Jean Mukamba',
    category: 'Cardiologie',
    description: 'Manuel complet pour le diagnostic des maladies cardiovasculaires en milieu tropical',
    fileSize: '2.4 MB',
    pages: 156,
    uploadDate: '2024-01-10',
    downloads: 245,
    rating: 4.8,
    tags: ['diagnostic', 'cardiologie', 'tropical'],
    thumbnail: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=300&h=200&fit=crop',
    fileUrl: '#'
  },
  {
    id: 2,
    title: 'Protocoles de vaccination pédiatrique',
    author: 'Dr. Marie Kabongo',
    category: 'Pédiatrie',
    description: 'Calendrier de vaccination adapté aux conditions locales de la RDC',
    fileSize: '1.8 MB',
    pages: 89,
    uploadDate: '2024-01-08',
    downloads: 189,
    rating: 4.9,
    tags: ['vaccination', 'pédiatrie', 'prévention'],
    thumbnail: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=300&h=200&fit=crop',
    fileUrl: '#'
  },
  {
    id: 3,
    title: 'Étude sur la prévalence du paludisme',
    author: 'Dr. Pierre Mbuyi',
    category: 'Recherche',
    description: 'Analyse épidémiologique du paludisme dans les zones urbaines de Kinshasa',
    fileSize: '3.2 MB',
    pages: 234,
    uploadDate: '2024-01-05',
    downloads: 156,
    rating: 4.7,
    tags: ['paludisme', 'épidémiologie', 'recherche'],
    thumbnail: 'https://images.unsplash.com/photo-1584515933487-779826dce0af?w=300&h=200&fit=crop',
    fileUrl: '#'
  },
  {
    id: 4,
    title: 'Manuel de chirurgie d\'urgence',
    author: 'Dr. Sarah Mwamba',
    category: 'Chirurgie',
    description: 'Procédures chirurgicales d\'urgence adaptées aux ressources limitées',
    fileSize: '4.1 MB',
    pages: 312,
    uploadDate: '2024-01-03',
    downloads: 298,
    rating: 4.9,
    tags: ['chirurgie', 'urgence', 'procédures'],
    thumbnail: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=300&h=200&fit=crop',
    fileUrl: '#'
  },
  {
    id: 5,
    title: 'Guide de nutrition thérapeutique',
    author: 'Dr. Joseph Kabila',
    category: 'Médecine générale',
    description: 'Recommandations nutritionnelles pour les patients diabétiques et hypertendus',
    fileSize: '1.5 MB',
    pages: 78,
    uploadDate: '2024-01-01',
    downloads: 167,
    rating: 4.6,
    tags: ['nutrition', 'diabète', 'hypertension'],
    thumbnail: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=300&h=200&fit=crop',
    fileUrl: '#'
  },
  {
    id: 6,
    title: 'Protocoles de soins intensifs',
    author: 'Dr. Grace Tshisekedi',
    category: 'Médecine générale',
    description: 'Standards de soins pour les unités de soins intensifs en RDC',
    fileSize: '2.8 MB',
    pages: 145,
    uploadDate: '2023-12-28',
    downloads: 203,
    rating: 4.8,
    tags: ['soins intensifs', 'protocoles', 'urgences'],
    thumbnail: 'https://images.unsplash.com/photo-1576091160550-2173dba0ef08?w=300&h=200&fit=crop',
    fileUrl: '#'
  }
];

export const mockElearningVideos = [
  {
    id: 1,
    title: 'Introduction à la cardiologie tropicale',
    instructor: 'Dr. Jean Mukamba',
    category: 'Cardiologie',
    level: 'Débutant',
    description: 'Cours complet sur les maladies cardiovasculaires en milieu tropical, incluant le diagnostic et le traitement des pathologies courantes.',
    duration: '45 min',
    views: 1250,
    rating: 4.8,
    thumbnail: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=225&fit=crop',
    videoUrl: '#',
    isCompleted: false,
    progress: 0,
    uploadDate: '2024-01-10',
    tags: ['cardiologie', 'tropical', 'diagnostic'],
    chapters: [
      { title: 'Introduction', duration: '5 min', isCompleted: false },
      { title: 'Anatomie du cœur', duration: '10 min', isCompleted: false },
      { title: 'Pathologies courantes', duration: '15 min', isCompleted: false },
      { title: 'Diagnostic différentiel', duration: '10 min', isCompleted: false },
      { title: 'Traitements', duration: '5 min', isCompleted: false }
    ]
  },
  {
    id: 2,
    title: 'Protocoles de vaccination pédiatrique',
    instructor: 'Dr. Marie Kabongo',
    category: 'Pédiatrie',
    level: 'Intermédiaire',
    description: 'Guide pratique pour la mise en place de programmes de vaccination efficaces en milieu rural et urbain.',
    duration: '38 min',
    views: 890,
    rating: 4.9,
    thumbnail: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=400&h=225&fit=crop',
    videoUrl: '#',
    isCompleted: true,
    progress: 100,
    uploadDate: '2024-01-08',
    tags: ['vaccination', 'pédiatrie', 'prévention'],
    chapters: [
      { title: 'Calendrier vaccinal', duration: '8 min', isCompleted: true },
      { title: 'Techniques d\'injection', duration: '12 min', isCompleted: true },
      { title: 'Gestion des effets secondaires', duration: '10 min', isCompleted: true },
      { title: 'Cas particuliers', duration: '8 min', isCompleted: true }
    ]
  },
  {
    id: 3,
    title: 'Chirurgie d\'urgence en conditions limitées',
    instructor: 'Dr. Sarah Mwamba',
    category: 'Chirurgie',
    level: 'Avancé',
    description: 'Techniques chirurgicales adaptées aux environnements avec ressources limitées et équipements de base.',
    duration: '52 min',
    views: 756,
    rating: 4.7,
    thumbnail: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=400&h=225&fit=crop',
    videoUrl: '#',
    isCompleted: false,
    progress: 35,
    uploadDate: '2024-01-05',
    tags: ['chirurgie', 'urgence', 'techniques'],
    chapters: [
      { title: 'Préparation du patient', duration: '8 min', isCompleted: true },
      { title: 'Anesthésie locale', duration: '12 min', isCompleted: true },
      { title: 'Techniques de base', duration: '15 min', isCompleted: false },
      { title: 'Gestion des complications', duration: '10 min', isCompleted: false },
      { title: 'Post-opératoire', duration: '7 min', isCompleted: false }
    ]
  },
  {
    id: 4,
    title: 'Diagnostic neurologique en première ligne',
    instructor: 'Dr. Pierre Mbuyi',
    category: 'Neurologie',
    level: 'Intermédiaire',
    description: 'Approche systématique du diagnostic des troubles neurologiques avec les moyens disponibles en première ligne.',
    duration: '41 min',
    views: 634,
    rating: 4.6,
    thumbnail: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=400&h=225&fit=crop',
    videoUrl: '#',
    isCompleted: false,
    progress: 0,
    uploadDate: '2024-01-03',
    tags: ['neurologie', 'diagnostic', 'examen clinique'],
    chapters: [
      { title: 'Examen neurologique', duration: '12 min', isCompleted: false },
      { title: 'Signes d\'alerte', duration: '8 min', isCompleted: false },
      { title: 'Pathologies courantes', duration: '15 min', isCompleted: false },
      { title: 'Orientation du patient', duration: '6 min', isCompleted: false }
    ]
  },
  {
    id: 5,
    title: 'Gestion des urgences médicales',
    instructor: 'Dr. Grace Tshisekedi',
    category: 'Urgences',
    level: 'Débutant',
    description: 'Protocoles de prise en charge des urgences médicales les plus fréquentes en milieu hospitalier.',
    duration: '33 min',
    views: 1120,
    rating: 4.8,
    thumbnail: 'https://images.unsplash.com/photo-1576091160550-2173dba0ef08?w=400&h=225&fit=crop',
    videoUrl: '#',
    isCompleted: false,
    progress: 60,
    uploadDate: '2024-01-01',
    tags: ['urgences', 'protocoles', 'réanimation'],
    chapters: [
      { title: 'Évaluation initiale', duration: '8 min', isCompleted: true },
      { title: 'Réanimation cardio-pulmonaire', duration: '12 min', isCompleted: true },
      { title: 'Choc et collapsus', duration: '8 min', isCompleted: false },
      { title: 'Troubles respiratoires', duration: '5 min', isCompleted: false }
    ]
  },
  {
    id: 6,
    title: 'Nutrition thérapeutique en médecine générale',
    instructor: 'Dr. Joseph Kabila',
    category: 'Médecine générale',
    level: 'Débutant',
    description: 'Intégration de la nutrition dans la prise en charge des patients chroniques et aigus.',
    duration: '29 min',
    views: 445,
    rating: 4.5,
    thumbnail: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&h=225&fit=crop',
    videoUrl: '#',
    isCompleted: false,
    progress: 0,
    uploadDate: '2023-12-28',
    tags: ['nutrition', 'thérapeutique', 'chronique'],
    chapters: [
      { title: 'Besoins nutritionnels', duration: '6 min', isCompleted: false },
      { title: 'Pathologies chroniques', duration: '10 min', isCompleted: false },
      { title: 'Supplémentation', duration: '8 min', isCompleted: false },
      { title: 'Suivi et évaluation', duration: '5 min', isCompleted: false }
    ]
  }
];
